export default __webpack_public_path__ + "static/media/floor.70dccf1b.svg";